export const locale = {
    lang: 'en',
    data: {
        CREATE_SUB_PROJECT: 'Create a subproject',
        GENERAL: 'General',
        MEMBERS: 'Members'
    }
};
